import { render, staticRenderFns } from "./scanningTabs.vue?vue&type=template&id=a5f5a556&"
import script from "./scanningTabs.vue?vue&type=script&lang=js&"
export * from "./scanningTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports